import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faEdit } from '@fortawesome/free-solid-svg-icons';

const AliasTable = ({ aliases, onEdit, onDeactivate }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field Key</th>
            <th>Original Value</th>
            <th>Replacement Value</th>
            <th>Created Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {aliases.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center text-muted">
                No aliases found
              </td>
            </tr>
          ) : (
            aliases.map((alias) => (
              <tr key={alias.id}>
                <td>
                  <span className="badge bg-primary">
                    {alias.fieldKey}
                  </span>
                </td>
                <td>
                  <code>{alias.originalValue}</code>
                </td>
                <td>
                  <code>{alias.replacementValue}</code>
                </td>
                <td>{formatDate(alias.createdAt)}</td>
                <td>
                  {alias.isActive ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-secondary">Inactive</span>
                  )}
                </td>
                <td>
                  {alias.isActive && (
                    <>
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => onEdit(alias)}
                        title="Edit Alias"
                      >
                        <FontAwesomeIcon icon={faEdit} /> Edit
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => onDeactivate(alias)}
                        title="Deactivate Alias"
                      >
                        <FontAwesomeIcon icon={faBan} /> Deactivate
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AliasTable;
